import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { VerifyOtpComponent } from '../verify-otp/verify-otp.component';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';

@Component({
  selector: 'app-signin-with-otp',
  templateUrl: './signin-with-otp.component.html',
  styleUrls: ['./signin-with-otp.component.scss']
})
export class SigninWithOtpComponent implements OnInit, OnChanges {

  @Input() isVisible: boolean = false;
  @Input() isDownloadDoc: boolean = false;
  @Input() tenderdetails: any;
  @Input() userRestrict: any;

  @ViewChild(VerifyOtpComponent) verifymodal!: VerifyOtpComponent;

  mobileNumber: string = '';
  whatsappConsent: boolean = true;
  isSignupButtonEnabled: boolean = false;

  otpIncorrect: boolean = false;
  errorMessage: string = '';

  constructor(private sharedService: SharedService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tenderdetails']) {
      this.cdr.detectChanges();
    }
  }

  /** Checks if a value contains only digits */
  isNumeric(value: string): boolean {
    return /^[0-9]*$/.test(value);
  }

  /** Enables or disables signup button based on mobile number validity */
  onInputChange(): void {
    this.isSignupButtonEnabled = this.mobileNumber.length === 10 && this.isNumeric(this.mobileNumber);
  }

  /** Prevents non-numeric input in the mobile number field */
  restrictNonNumeric(event: KeyboardEvent): void {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  openSignupModal() {
    if (this.mobileNumber) {
      this.sharedService.otpSend(this.mobileNumber).subscribe(
        (res: any) => {
          this.patchVerifyModal(res?.data?.requestId);
          this.isVisible = false;
        },
        (error: any) => {
          this.otpIncorrect = true;
          this.errorMessage = "OTP limit reached. Please try again in 15 minutes.";
        }
      );
    }
  }

  /** Populates and opens the VerifyOtpComponent modal */
  private patchVerifyModal(requestId: string): void {
    if (!this.verifymodal) return;

    Object.assign(this.verifymodal, {
      mobileNumber: this.mobileNumber,
      requestId: requestId,
      tenderdetails: this.tenderdetails,
      openVerifyOTP: true,
      whatsappConsent: this.whatsappConsent
    });

    this.cdr.detectChanges();
    this.verifymodal.startCountdown();
  }

  enableSignupButton() {
    this.isSignupButtonEnabled = true;
  }

  disableSignupButton() {
    this.isSignupButtonEnabled = false;
  }

  closeModal() {
    this.isVisible = false;
  }
}